module.exports = __webpack_public_path__ + "static/media/wn_24.ab07952a.jpg";